var icon = require('vue-svgicon')
icon.register({
  'ks-icon-sort-asc': {
    width: 128,
    height: 128,
    viewBox: '0 0 128 128',
    data: '<path pid="0" d="M39.52 72.21L64 96.69l24.48-24.48L96 79.79l-32 32-32-32z"/>'
  }
})
